import vsf, { definePage } from '@vs/vsf-boot';
import { Page } from '@vs/vsf-kit';
import React from 'react';

const RoleManage = (props) => {
  return <Page title="RoleManage"></Page>;
};

export default definePage(RoleManage);
